import { PaymentGatewayTransactionTypes } from '@anchorbase/pillar-sdk';
import { TransactionsListContent } from './TransactionsListContent';

export function PaymentTransactionsContent() {
    return (
        <TransactionsListContent
            pageTitle="Payment Transactions"
            loadingLabel="Loading payment transactions..."
            endOfListLabel="End of payment transactions."
            amountColumnVisible={true}
            detailBasePath="/payment-transactions"
            gatewayTransactionTypes={PaymentGatewayTransactionTypes}
        />
    );
}
